import { UNMATCHED_FILE_LAST_SEEN_RANGE } from './constants';

export const getLastSeenRangeDates = range => {
  // computed in UTC
  const startOfUtcDay = date => {
    const next = new Date(date);
    next.setUTCHours(0, 0, 0, 0);
    return next;
  };

  const today = startOfUtcDay(new Date());

  const daysAgo = days => {
    const date = new Date(today);
    date.setUTCDate(today.getUTCDate() - days);
    return date;
  };

  switch (range) {
    case UNMATCHED_FILE_LAST_SEEN_RANGE.Last30Days:
      return { startDate: daysAgo(30) };
    case UNMATCHED_FILE_LAST_SEEN_RANGE.Days30To60:
      return { startDate: daysAgo(60), endDate: daysAgo(30) };
    case UNMATCHED_FILE_LAST_SEEN_RANGE.Days60Plus:
      return { endDate: daysAgo(60) };
    default:
      return {};
  }
};

export const buildSharedParams = filters => {
  const params = {};

  if (filters?.tagId !== undefined && filters?.tagId !== null && filters?.tagId !== '') {
    params.customerEnvironmentTagId = filters.tagId;
  }
  if (filters?.trustStatus) {
    params.trustStatus = filters.trustStatus;
  }
  if (filters?.trustSignal) {
    params.trustSignalColumn = filters.trustSignal;
  }

  const { startDate, endDate } = getLastSeenRangeDates(filters?.lastSeenRange);
  if (startDate) {
    params.lastSeenStartDate = startDate.toISOString();
  }
  if (endDate) {
    params.lastSeenEndDate = endDate.toISOString();
  }

  return params;
};
